export default {
   tmpMainMenuBorderColor: 'transparent',
   tmpMainMenuLineColor: '#bbb',
   tmpMainMenuButtonActiveBackgroundColor: '#000',
   tmpMainMenuButtonActiveTextColor: '#f5f4eb',
   tmpMainMenuButtonTextColor: '#666',
   tmpBackgroundColor: '#f5f4eb',
   tmpContentBackgroundColor: '#f5f4eb',
   tmpContentLineColor: 'rgba(0,0,0,0.4)',
   tmpMainMenuBackgroundColor: '#f5f4eb',
   tmpViewportPadding: '20px[a] 20px[b] 40px[c] 30px[d] 4vw[e] calc(50vw - 850px + 150px)[f]',
   tmpViewportPaddingE: '4vw',
   tmpViewportPaddingF: 'calc(50vw - 850px + 150px)'
}
